/* eslint-disable */
var _0x3daf = [
  "\x31\x30\x38\x39\x34\x33\x33\x56\x4e\x4e\x44\x45\x51",
  "\x31\x31\x44\x76\x69\x4e\x68\x53",
  "\x31\x75\x63\x47\x79\x47\x55",
  "\x63\x61\x6e\x76\x61\x73\x20\x69\x6e\x6a\x65\x63\x74\x20",
  "\x6c\x6f\x67",
  "\x67\x65\x74\x45\x6c\x65\x6d\x65\x6e\x74\x73\x42\x79\x54\x61\x67\x4e\x61\x6d\x65",
  "\x31\x63\x6d\x77\x59\x75\x69",
  "\x6e\x61\x6d\x65",
  "\x77\x72\x74\x63\x72\x65\x61\x64",
  "\x23\x23\x23\x65\x6e\x64",
  "\x69\x6e\x64\x65\x78\x4f\x66",
  "\x31\x30\x33\x32\x36\x37\x6d\x65\x70\x50\x4c\x66",
  "\x75\x6e\x64\x65\x66\x69\x6e\x65\x64",
  "\x65\x70\x75\x62\x2d\x63\x6f\x6e\x74\x65\x6e\x74",
  "\x63\x6f\x6c",
  "\x31\x30\x39\x33\x34\x38\x33\x7a\x55\x70\x62\x70\x49",
  "\x70\x61\x67\x65\x3a\x72\x65\x61\x64\x79",
  "\x69\x6d\x67\x3d\x30",
  "\x45\x42\x43\x4c\x6f\x67\x67\x65\x72",
  "\x62\x6f\x6f\x6b\x3a\x6e\x61\x76\x69\x67\x61\x74\x69\x6f\x6e\x52\x65\x71\x75\x65\x73\x74\x65\x64",
  "\x69\x6e\x6e\x65\x72\x54\x65\x78\x74",
  "\x37\x38\x36\x33\x36\x35\x44\x58\x6a\x65\x76\x58",
  "\x23\x23\x23\x74\x65\x78\x74\x3d",
  "\x6c\x65\x6e\x67\x74\x68",
  "\x73\x63\x72\x75\x62\x62\x65\x72\x2d\x63\x6f\x6e\x74\x61\x69\x6e\x65\x72",
  "\x23\x23\x23\x6a\x73\x65\x6e\x64\x3d",
  "\x31\x76\x69\x51\x70\x4c\x71",
  "\x31\x34\x33\x36\x36\x31\x30\x54\x65\x47\x5a\x41\x6f",
  "\x61\x64\x64\x45\x76\x65\x6e\x74\x73",
  "\x33\x33\x39\x35\x36\x35\x37\x44\x45\x56\x48\x75\x48",
  "\x73\x68\x65\x65\x74\x73\x20\x25\x73\x20\x25\x73",
  "\x6d\x6f\x6c\x72\x74",
  "\x6d\x6f\x6c\x72\x65\x61",
  "\x6d\x6f\x6c\x6d\x6c",
  "\x69\x6e\x6a\x65\x63\x74\x20\x72\x75\x6e",
  "\x31\x4d\x47\x75\x66\x70\x51",
  "\x61\x70\x70\x6c\x79",
  "\x31\x34\x36\x30\x39\x38\x32\x65\x43\x43\x67\x52\x5a",
  "\x56\x69\x65\x77\x65\x72",
  "\x64\x6f\x63\x20\x25\x64\x20\x69\x6d\x67\x20\x25\x64",
  "\x46\x72\x61\x63\x74\x69\x6f\x6e"
];
function _0x5a99(_0x1c3b59, _0x3671be) {
  _0x1c3b59 = _0x1c3b59 - 0x13e;
  var _0x3daf4c = _0x3daf[_0x1c3b59];
  return _0x3daf4c;
}
(function (_0x2c8f8c, _0x485c9f) {
  var _0x25a874 = _0x5a99;
  while (!![]) {
    try {
      var _0x1f50da =
        -parseInt(_0x25a874(0x15a)) +
        -parseInt(_0x25a874(0x164)) +
        -parseInt(_0x25a874(0x140)) * -parseInt(_0x25a874(0x14a)) +
        parseInt(_0x25a874(0x13f)) * parseInt(_0x25a874(0x141)) +
        -parseInt(_0x25a874(0x14e)) * parseInt(_0x25a874(0x159)) +
        parseInt(_0x25a874(0x154)) * -parseInt(_0x25a874(0x162)) +
        -parseInt(_0x25a874(0x145)) * -parseInt(_0x25a874(0x15c));
      if (_0x1f50da === _0x485c9f) break;
      else _0x2c8f8c["push"](_0x2c8f8c["shift"]());
    } catch (_0xb75d4a) {
      _0x2c8f8c["push"](_0x2c8f8c["shift"]());
    }
  }
})(_0x3daf, 0xcdf43),
  (function () {
    var _0x22dbf6 = _0x5a99,
      _0x4a3e91 = ![];
    console[_0x22dbf6(0x143)] = (function () {
      var _0x2e611d = _0x22dbf6,
        _0x4e24d0 = console[_0x2e611d(0x143)];
      return function () {
        var _0x2df8be = _0x2e611d;
        try {
          if (
            arguments[0x0] === _0x2df8be(0x15d) ||
            arguments[0x0] === _0x2df8be(0x14c) ||
            arguments[0x0] === _0x2df8be(0x150) ||
            arguments[0x0] === _0x2df8be(0x148) ||
            arguments[0x0]["\x69\x6e\x64\x65\x78\x4f\x66"](_0x2df8be(0x161)) ===
              0x0 ||
            arguments[0x0][_0x2df8be(0x149)](_0x2df8be(0x155)) === 0x0 ||
            arguments[0x0][_0x2df8be(0x149)](_0x2df8be(0x166)) === 0x0 ||
            arguments[0x0][_0x2df8be(0x149)](
              "\x68\x65\x61\x64\x20\x70\x6c\x75\x67\x69\x6e\x73\x20\x73\x65\x74\x74\x69\x6e\x67"
            ) === 0x0 ||
            arguments[0x0][_0x2df8be(0x149)](_0x2df8be(0x158)) === 0x0 ||
            arguments[0x0][_0x2df8be(0x149)](_0x2df8be(0x142)) === 0x0
          ) {
            if (!_0x4a3e91) {
              _0x4a3e91 = !![];
              var _0x1a9a66 = {};
              (_0x1a9a66["\x6e\x61\x6d\x65"] = _0x2df8be(0x151)),
                (_0x1a9a66["\x6d"] = _0x2df8be(0x14d)),
                (_0x1a9a66["\x66"] = "\x66"),
                Jigsaw["\x61\x64\x64\x45\x76\x65\x6e\x74\x73"]([_0x1a9a66]);
            }
          }
        } catch (_0x21c77f) {}
        _0x4e24d0[_0x2df8be(0x163)](console, arguments);
      };
    })();
    var _0x528780 = function () {},
      _0x4c3f4b = ![],
      _0x5b57d4 = ![],
      _0x253ec5 = ![],
      _0x2fade6 = ![],
      _0x12068b = 0x0,
      _0x31c26a = 0x0,
      _0x1e8f29 = ![];
    function _0x43f94d() {
      var _0xc90d50 = _0x22dbf6;
      if (_0x12068b > 0x4 && _0x12068b - _0x31c26a > 0x4) {
        if (!_0x1e8f29) {
          _0x1e8f29 = !![];
          var _0x59a83e = {};
          (_0x59a83e["\x6e\x61\x6d\x65"] = _0xc90d50(0x151)),
            (_0x59a83e["\x6d"] = "\x72\x65\x6e\x61\x72\x61"),
            (_0x59a83e["\x66"] = "\x66"),
            Jigsaw["\x61\x64\x64\x45\x76\x65\x6e\x74\x73"]([_0x59a83e]);
        }
      }
    }
    var _0x218ca8 = function () {
      var _0x1c8277 = _0x22dbf6,
        _0x41f249 = document["\x68\x65\x61\x64"][_0x1c8277(0x144)](
          "\x73\x74\x79\x6c\x65"
        );
      for (
        var _0x1dc044 = 0x0;
        _0x1dc044 < _0x41f249[_0x1c8277(0x156)];
        _0x1dc044++
      ) {
        if (
          _0x41f249[_0x1dc044][_0x1c8277(0x153)][_0x1c8277(0x149)](
            _0x1c8277(0x157)
          ) > 0x0
        ) {
        }
      }
      !_0x2fade6 &&
        window[_0x1c8277(0x13e)][_0x1c8277(0x165)] &&
        window["\x46\x72\x61\x63\x74\x69\x6f\x6e"][_0x1c8277(0x165)][
          "\x62\x69\x6e\x64"
        ] &&
        ((_0x2fade6 = !![]),
        window["\x46\x72\x61\x63\x74\x69\x6f\x6e"][_0x1c8277(0x165)][
          "\x62\x69\x6e\x64"
        ](_0x1c8277(0x14f), function () {
          (_0x12068b = _0x12068b + 0x1), _0x43f94d();
        }),
        window[_0x1c8277(0x13e)]["\x56\x69\x65\x77\x65\x72"][
          "\x62\x69\x6e\x64"
        ](_0x1c8277(0x152), function () {
          _0x31c26a = _0x31c26a + 0x1;
        }));
      var _0x214249 = typeof mylog !== _0x1c8277(0x14b),
        _0xf2780a = typeof window[_0x1c8277(0x147)] !== _0x1c8277(0x14b);
      if (_0x214249 || _0xf2780a) {
        if (!_0x5b57d4) {
          _0x5b57d4 = !![];
          var _0x120a63 =
              _0xf2780a && _0x214249
                ? "\x6d\x6f\x6c\x72"
                : _0xf2780a
                ? _0x1c8277(0x15e)
                : _0x1c8277(0x160),
            _0x13e50a = {};
          (_0x13e50a[_0x1c8277(0x146)] = _0x1c8277(0x151)),
            (_0x13e50a["\x6d"] = _0x120a63),
            (_0x13e50a["\x66"] = "\x66"),
            Jigsaw["\x61\x64\x64\x45\x76\x65\x6e\x74\x73"]([_0x13e50a]);
        }
        if (!_0x253ec5 && _0x12068b >= 0x14) {
          _0x253ec5 = !![];
          var _0x295221 = {};
          (_0x295221[_0x1c8277(0x146)] = _0x1c8277(0x151)),
            (_0x295221["\x6d"] = _0x1c8277(0x15f)),
            (_0x295221["\x66"] = "\x66"),
            Jigsaw[_0x1c8277(0x15b)]([_0x295221]);
        }
      }
    };
    setInterval(_0x218ca8, 0xbb8);
  })();
